<template>
  <WhitePage :loading="loading">
    <title-bar>異世界リスト</title-bar>
    <!-- <result-nav></result-nav> -->
    <!-- <list-nav /> -->
    <select-list :items="list"
      :fields="[
        { key:'name', label:'世界名', sortable:true },
        { key:'lastUpdate', label:'最終更新日', sortable:true },
        { key:'nextUpdate', label:'次回更新日', sortable:true }
      ]"
      :perPage="20"
      :selectable="false"
      tableKey='RID'
    >
      <template v-slot:cell(name)="row">
        <router-link :to="'/world/'+row.item.RID">
          {{ row.item.name }}
        </router-link>
      </template>
      <template v-slot:cell(lastUpdate)="row">
        {{ lastUpdate(row) }}
      </template>
      <template v-slot:cell(nextUpdate)="row">
        {{ nextUpdate(row) }}
      </template>
    </select-list>
  </WhitePage>
</template>

<script>
import phina from 'phina.js'
import store from '@/store'
import WhitePage from '@/components/WhitePage'
import CheckLogin from '@/components/mixin-checkLogin'
import TitleBar from '@/components/TitleBar'
// import ResultNav from '@/components/ResultNav'
import SelectList from '@/components/SelectList'
// import ListNav from '@/components/ListNav'
import moment from 'moment/src/moment'
export default {
  components: {
    WhitePage,
    TitleBar,
    // ResultNav,
    SelectList,
    // ListNav
  },
  data () {
    return {
      list: [],
      loading: false
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
      this.list = response.list
    },
    lastUpdate: (row)=> moment(new Date(row.item.lastUpdate*1000)).format('YYYY/MM/DD'),
    nextUpdate: (row)=> moment(new Date(row.item.nextUpdate*1000)).format('YYYY/MM/DD'),
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getWorldList')
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    // this.checkLogin()
  },
  mounted () {
    phina.global.app.currentScene.exit('MainScene')
  }
}
</script>

<style lang="scss" scoped>
.eno {
  position: relative;
  top: 20px;
  font-size: medium;
}
#manage ::v-deep .manage-table {
  overflow-x: scroll;

  table {
    width: 1000px;
  }
}
</style>
